/**
 * Утилита для кодирования и декодирования URL-переменных ("foo=bar&baz=di")
 *
 * @class
 */
var Params = function ($) {

    /**
     * @param {Object<String>} [obj]
     * @constructor
     */
    function Params(obj) {
        if (obj) {
            $.extend(this, obj);
        }
    }

    /**
     * Преобразует текущий location.hash (то что после # в строке адреса)
     * @returns {Params}
     */
    Params.fromHash = function () {
        return Params.parse(window.location.hash.substr(1));
    };

    /**
     * Преобразует текущий location.search (то что после ? в строке адреса)
     * @returns {Params}
     */
    Params.fromSearch = function () {
        return Params.parse(window.location.search.substr(1));
    };

    /**
     * @param {String} [glue='&']
     * @param {String} [eq='=']
     * @returns {String}
     */
    Params.prototype.toString = function (glue, eq) {
        glue = glue || '&';
        eq = eq || '=';
        var resArr = [];
        for (var key in this) {
            if (!this.hasOwnProperty(key)) {
                continue;
            }
            resArr.push(encodeURIComponent(key) + eq + encodeURIComponent(this[key]));
        }
        return resArr.join(glue);
    };

    /**
     * @param {Object<String>} obj
     * @param {String} [glue='&']
     * @param {String} [eq='=']
     * @returns {String}
     */
    Params.stringify = function (obj, glue, eq) {
        return new Params(obj).toString(glue, eq);
    };

    /**
     * @param {String} str
     * @param {String} [glue='&']
     * @param {String} [eq='=']
     * @returns {Params}
     */
    Params.parse = function (str, glue, eq) {
        glue = glue || '&';
        eq = eq || '=';
        var res = new Params();
        if (str.length) {
            var paramsArr = str.split(glue);
            for (var i = 0; i < paramsArr.length; i++) {
                var param = paramsArr[i].split(eq, 2);
                res[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
            }
        }
        return res;
    };

    return Params;

}(jQuery);
